import { useAuthenticator } from "@aws-amplify/ui-react";
import { Settings } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "./ui/button";

export function Header() {
  const navigate = useNavigate();

  const { user, signOut } = useAuthenticator((context) => [context.user, context.signOut]);

  const handleSignOut = async () => {
    try {
      signOut();
      navigate("/");
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  return (
    <header className="flex justify-between items-center p-4 bg-white border-b">
      <div className="flex items-center space-x-6">
        <Link to="/characters" className="text-xl font-bold hover:text-gray-700 transition-colors">
          Narichat2
        </Link>
        <nav className="flex items-center space-x-4">
          <Link to="/characters" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
            キャラクター
          </Link>
          <Link
            to="/llm-configs"
            className="flex items-center text-sm text-gray-600 hover:text-gray-900 transition-colors"
          >
            <Settings className="h-4 w-4 mr-1" />
            LLM設定
          </Link>
        </nav>
      </div>
      <div className="flex items-center space-x-4">
        <span className="text-sm text-gray-600">{user?.signInDetails?.loginId}</span>
        <Button onClick={handleSignOut} variant="outline" size="sm">
          ログアウト
        </Button>
      </div>
    </header>
  );
}
